import * as React from 'react'

import { _route } from 'routes/config'
import ResetPassword from './ResetPassword'
import { VerifyEmail } from './VerifyEmail'

export const EmailHandler = ({ location, history }) => {
  const [mode, setMode] = React.useState<string | null>('')

  const [oobCode, setOobCode] = React.useState<string | null>('')

  React.useEffect(() => {
    if (location?.search) {
      const smode = new URLSearchParams(location.search).get('mode')
      const soobCode = new URLSearchParams(location.search).get('oobCode')

      smode ? setMode(smode) : history.push(_route.root)
      soobCode ? setOobCode(soobCode) : history.push(_route.root)
    }
  }, [location?.search])

  const renderPage = currentMode => {
    switch (currentMode) {
      case 'resetPassword':
        return <ResetPassword oobCode={oobCode} />

      case 'verifyEmail':
        return <VerifyEmail oobCode={oobCode} />

      default:
        return history.push(_route.root)
    }
  }

  return <div>{mode && oobCode && renderPage(mode)}</div>
}



// WEBPACK FOOTER //
// ./src/pages/EmailHandler/index.tsx